import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";

export interface SequenceInsertSlotDragProps {
  readonly insertBeforeIndex: number;
  readonly isActive: boolean;
  readonly onDragOverGap: (insertBeforeIndex: number) => void;
  readonly onDropGap: (insertBeforeIndex: number) => void;
}

export interface SequenceInsertSlotProps {
  readonly disabled?: boolean;
  readonly label: string;
  readonly onInsert?: () => void;
  readonly drag?: SequenceInsertSlotDragProps;
  readonly isDragging?: boolean;
}

/** Hover-activated + control between sequence cards; optional drag-drop target during reorder. */
export function SequenceInsertSlot({
  disabled,
  label,
  onInsert,
  drag,
  isDragging = false,
}: SequenceInsertSlotProps) {
  const showInsert = Boolean(onInsert) && !disabled;
  const showDrop = Boolean(drag) && isDragging;

  const className = [
    "teacher-sequence-insert-gap",
    showDrop && drag?.isActive ? " is-active" : "",
    isDragging ? " is-drag-context" : "",
  ].join("");

  return (
    <li
      className={className}
      aria-hidden={showDrop && !drag?.isActive ? true : undefined}
      onDragEnter={
        drag
          ? (e) => {
              e.preventDefault();
              drag.onDragOverGap(drag.insertBeforeIndex);
            }
          : undefined
      }
      onDragOver={
        drag
          ? (e) => {
              e.preventDefault();
              e.dataTransfer.dropEffect = "move";
              drag.onDragOverGap(drag.insertBeforeIndex);
            }
          : undefined
      }
      onDrop={
        drag
          ? (e) => {
              e.preventDefault();
              e.stopPropagation();
              drag.onDropGap(drag.insertBeforeIndex);
            }
          : undefined
      }
    >
      <div className="teacher-sequence-insert-slot">
        {showDrop && drag?.isActive ? (
          <span className="teacher-sequence-drop-label">Drop here</span>
        ) : null}
        {showInsert ? (
          <button
            type="button"
            className="teacher-sequence-insert-btn"
            aria-label={label}
            title={label}
            onClick={onInsert}
          >
            <FontAwesomeIcon icon={faPlus} />
          </button>
        ) : null}
      </div>
    </li>
  );
}
